module.exports = __webpack_public_path__ + "static/img/5-3.56e36676.png";